export function isExpired(token: string): boolean {
  try {
    const splits = token.split(".");
    if (splits.length < 2) throw new Error("Invalid token");

    const data = splits[1];
    if (!data) throw new Error("Invalid token");

    const payload = JSON.parse(atob(data));

    // Treat as expired 15s early to avoid edge-case clock skew
    return Date.now() > (payload.exp ?? 0) * 1000 - 15_000;
  } catch {
    return true;
  }
}
